import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faRocket } from '@fortawesome/pro-solid-svg-icons';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

import { svgWithJs, variables } from '../variables';

interface RecentlyAddedOrganization {
  id: number;
  name: string;
  organizationType: string;
  profileUrl: string;
}

@customElement('apt-home-notifications')
export class AptHomeNotifications extends LitElement {
  @property({ type: Array })
  data: Array<RecentlyAddedOrganization> = [];

  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        .container {
          display: flex;
          flex-direction: column;
        }
        .row {
          display: flex;
          flex-direction: row;
          text-decoration: none;
          margin-bottom: 1rem;
          color: var(--link-color);
        }
        .icon-section {
          display: flex;
          margin: 0.5rem 0.25rem 0 1rem;
          flex: 0 0 auto;
          width: 8.33333333%;
        }
        .description-section {
          display: flex;
          flex-direction: column;
          flex: 0 0 auto;
          width: 83.33333333%;
        }

        .organization-type {
          font-size: 14px;
          line-height: 1.2;
          font-weight: 500;
          margin: 0;
        }
        .organization-name {
          line-height: 1;
        }
      `,
    ];
  }

  override render() {
    return html` <div class="container">
      ${repeat(
        this.data,
        (organization) => organization.id,
        (organization, index) => html`
          <a class="row" href="${organization.profileUrl}">
            <div class="icon-section">
              <i class="fas fa-rocket fa-lg"></i>
            </div>
            <div class="description-section">
              <h4 class="organization-type">
                New Aptitude ${organization.organizationType}
              </h4>
              <span class="organization-name"><u>${organization.name}</u></span>
            </div>
          </a>
        `,
      )}
    </div>`;
  }

  protected override firstUpdated(): void {
    library.add(faRocket);
    // @ts-ignore The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'apt-home-notifications': AptHomeNotifications;
  }
}
